// lodash get function
export default function get<T>(
  object: T,
  path: string | Array<string | number>,
  defaultValue?: any
): any {
  if (!object || typeof object !== 'object') {
    return defaultValue;
  }

  const pathArray = Array.isArray(path) ? path : path.match(/[^.[\]]+/g) || [];

  let result: any = object;
  for (const key of pathArray) {
    result = result != null ? result[key as keyof typeof result] : undefined;
    if (result === undefined) {
      return defaultValue;
    }
  }

  return result;
}
